import { KeyValue } from './keyValue.d';

export enum TaxRateType {
    RWT,
    NRWT,
    AIL,
    PIE
}

export interface ITaxRateSchedule {
    entityLegalType: number;
    incomeTierDescription: string;
    isDefault: boolean;
    tag: string;
    taxRate: number;
    taxRatePercentage: number;
    taxRateType: TaxRateType;
}

export interface IMappedTaxRateSchedule {
    RWTTaxRateSchedule?: KeyValue[];
    PIRTaxRateSchedule?: KeyValue[];
}

export interface ITaxRateSelectOption extends KeyValue {
    isDefault: boolean;
}
